import { CULTURE, PID } from '@/composables/helpers'
import type { IAccoItem, ISaveEnquiryResponse } from '@/composables/Interfaces/apiInterfaces'
import type { IEnquiryDto, IEnquiryFilter, IEnquiryFormValues } from '@/composables/Interfaces/appInterfaces'
import { ref } from 'vue'
import dayjs from 'dayjs'
import { filterStore } from './filter.store'
import { cartStore } from './cart.store'

export const enquiryData = ref<IEnquiryDto>()

export function castToEnquiryDtoAndSaveToStore(
  enquiryFormData: IEnquiryFormValues,
  directEnquiry: boolean,
  companyIds: number[],
  enquiryFilter: IEnquiryFilter,
  roomTag: string | undefined
): IEnquiryDto {
  var data: IEnquiryDto = {
    portalId: PID,
    language: CULTURE,
    enquiryType: directEnquiry ? EnquiryType.Direct : EnquiryType.General,
    referer: undefined, // set in controller
    track: undefined, // set in controller
    ip: undefined, // set in controller

    arrival: dayjs(enquiryFormData.date[0]).format('YYYY-MM-DD'),
    departure: dayjs(enquiryFormData.date[1]).format('YYYY-MM-DD'),
    rooms: enquiryFormData.occupancy.rooms?.map((x) => ({
      adults: x.adults || 0,
      children: x.children || 0,
      childrenAges: x.childrenAges || []
    })),
    hasPets: enquiryFormData.occupancy.pets.hasPets,
    petsMessage: enquiryFormData.occupancy.pets.message,
    title: enquiryFormData.title,
    firstname: enquiryFormData.firstname,
    lastname: enquiryFormData.surname,
    email: enquiryFormData.email,
    phone: enquiryFormData.phone,
    message: enquiryFormData.message,
    privacy: enquiryFormData.privacy,
    newsletter: enquiryFormData.newsletter,

    companyIds: companyIds,
    wishedOffers: companyIds.length, //used for tickets
    filter: enquiryFilter,
    tag: roomTag
  }

  //saving the enquiryData also in the store to be able to make a enquiry with one click on the enquirysuccesspage
  enquiryData.value = data
  return data
}

export function trackEnquiry(enquiryData: IEnquiryDto, result: ISaveEnquiryResponse, landingPageEnquiry: boolean): void {
  // window.siteEventEnquiry is only declared in portal project, here locally its missing
  if (landingPageEnquiry) {
    window.siteEventEnquiryLandingPage && window.siteEventEnquiryLandingPage(enquiryData.enquiryType, enquiryData.language)
  } else {
    window.siteEventEnquiry && window.siteEventEnquiry(enquiryData, result)
  }
}

export function setBoardingsToOnlyAccomodationIfEmptyArray(): void {
  if (filterStore.value.boardingIds.length == 0) filterStore.value.boardingIds.push(0)
}

export function removeCidsFromCartLocalStorage(cids?: number[]): void {
  if (cids != null) {
    cids.forEach((cid: number) => {
      const index = cartStore.value.accos.findIndex((x: IAccoItem) => x.companyId === cid)
      if (index > -1) {
        cartStore.value.accos.splice(index, 1)
      }
    })
  }
}

export enum EnquiryType {
  General = 1,
  Direct = 2,
  Collective = 3
}

declare global {
  interface Window {
    siteEventEnquiry: any
    siteEventEnquiryLandingPage: any
    siteEvent?: (cat: 'button' | (string & {}), act: 'micropage' | 'enquiry-direct' | 'enquiry-success-extend' | 'cart' | (string & {}), lab: string) => void
  }
}

declare module 'vue' {
  interface ComponentCustomProperties {
    $window: Window
  }
}
